module.exports = "<!-- $Id: main.html 54447 2017-07-26 23:34:29Z eduardo.s.neto $-->\r\n<header></header>\r\n<router-outlet></router-outlet>\r\n<app-footer></app-footer>\r\n<template ngbModalContainer></template>\r\n<app-alert></app-alert>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/main.html
// module id = 1122
// module chunks = 1